(function () {
  'use strict';

  function initCertificationHub() {
  try {
  var stickyNav = document.querySelector('.dxp-sticky-nav');
  var stickyLinks = Array.prototype.slice.call(document.querySelectorAll('.dxp-sticky-nav a[href^="#"]'));
  var sectionTargets = stickyLinks.map(function (link) {
    var id = link.getAttribute('href').slice(1);
    return document.getElementById(id);
  }).filter(Boolean);

  function setActiveNav(id) {
    stickyLinks.forEach(function (link) {
      var isActive = link.getAttribute('href') === '#' + id;
      link.classList.toggle('is-active', isActive);
      if (isActive) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
      if (isActive && link.parentElement && link.parentElement.scrollTo) {
        var centeredLeft = link.offsetLeft - (link.parentElement.clientWidth / 2) + (link.offsetWidth / 2);
        try {
          link.parentElement.scrollTo({ left: centeredLeft, behavior: 'smooth' });
        } catch (error) {
          link.parentElement.scrollLeft = centeredLeft;
        }
      }
    });
  }

  if (stickyNav && stickyLinks.length) {
    stickyLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setActiveNav(id);
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });

    if ('IntersectionObserver' in window && sectionTargets.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActiveNav(entry.target.id);
        });
      }, { rootMargin: '-30% 0px -55% 0px', threshold: 0.01 });

      sectionTargets.forEach(function (target) {
        observer.observe(target);
      });
    } else if (sectionTargets.length) {
      window.addEventListener('scroll', function () {
        var active = sectionTargets[0];
        sectionTargets.forEach(function (target) {
          if (target.getBoundingClientRect().top < 160) active = target;
        });
        setActiveNav(active.id);
      }, { passive: true });
    }

    window.addEventListener('scroll', function () {
      stickyNav.classList.toggle('is-stuck', window.scrollY > 20);
    }, { passive: true });

    if (window.location.hash) {
      setActiveNav(window.location.hash.slice(1));
    } else if (sectionTargets[0]) {
      setActiveNav(sectionTargets[0].id);
    }
  }

  /* ══════════════════════════
     JOURNEY CARD ACCORDION
     ══════════════════════════ */
  document.querySelectorAll('.dxp-journey__card-head').forEach(function (head) {
    head.addEventListener('click', function () {
      var card   = head.closest('.dxp-journey__card');
      var isOpen = card.classList.contains('is-open');

      /* Close all */
      document.querySelectorAll('.dxp-journey__card').forEach(function (other) {
        other.classList.remove('is-open');
        var otherHead = other.querySelector('.dxp-journey__card-head');
        if (otherHead) otherHead.setAttribute('aria-expanded', 'false');
      });

      /* Open clicked if it was closed */
      if (!isOpen) {
        card.classList.add('is-open');
        head.setAttribute('aria-expanded', 'true');
      }
    });

    /* Keyboard: allow Enter/Space to toggle */
    head.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        head.click();
      }
    });
  });


  /* ══════════════════════════
     FAQ ACCORDION
     ══════════════════════════ */
  document.querySelectorAll('.dxp-faq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item   = btn.closest('.dxp-faq');
      var isOpen = item.classList.contains('is-open');

      /* Close all */
      document.querySelectorAll('.dxp-faq').forEach(function (other) {
        other.classList.remove('is-open');
        var ob = other.querySelector('.dxp-faq__q');
        if (ob) ob.setAttribute('aria-expanded', 'false');
      });

      /* Open clicked if it was closed */
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });


	  /* ══════════════════════════
	     BATCH NUMBER SEARCH
	     ══════════════════════════ */
	  var batchSearch = document.getElementById('dxp-batch-search');
	  var batchResult = document.getElementById('dxp-batch-result');
	  var batchCards  = Array.prototype.slice.call(document.querySelectorAll('.dxp-card--coa'));
	  var batchTool = batchSearch ? batchSearch.closest('.dxp-batch-tool') : null;
	  var verifyTimer = null;

	  function resetBatchCards() {
	    batchCards.forEach(function (card) {
	      card.classList.remove('is-hidden', 'is-match');
	    });
	  }

	  function setBatchResultState(state) {
	    batchResult.classList.remove('is-success', 'is-warning');
	    if (state) batchResult.classList.add(state);
	  }

	  function playVerifyAnimation() {
	    if (!batchTool) return;
	    batchTool.classList.remove('is-verifying');
	    void batchTool.offsetWidth;
	    batchTool.classList.add('is-verifying');
	    window.clearTimeout(verifyTimer);
	    verifyTimer = window.setTimeout(function () {
	      batchTool.classList.remove('is-verifying');
	    }, 600);
	  }

	  if (batchSearch && batchResult && batchCards.length) {
	    batchSearch.addEventListener('input', function () {
	      var value = batchSearch.value.trim().toUpperCase().replace(/\s+/g, '');
	      playVerifyAnimation();

	      if (!value) {
	        resetBatchCards();
	        setBatchResultState(null);
	        batchResult.textContent = 'Type a batch number to highlight the matching COA.';
	        return;
	      }

	      var matchedCard = null;
	      var possibleMatches = 0;
	      batchCards.forEach(function (card) {
	        var batch = card.getAttribute('data-batch');
	        var isMatch = batch === value;
	        var isPossible = batch.indexOf(value) === 0;
	        card.classList.toggle('is-hidden', !isPossible);
	        card.classList.toggle('is-match', isMatch);
	        if (isPossible) possibleMatches += 1;
	        if (isMatch) matchedCard = card;
	      });

	      if (matchedCard) {
	        var product = matchedCard.getAttribute('data-product');
	        var href    = matchedCard.getAttribute('data-href');
	        var link    = document.createElement('a');
	        link.href        = href;
	        link.textContent = 'Open the COA';
	        setBatchResultState('is-success');
	        batchResult.textContent = '';
	        batchResult.appendChild(document.createTextNode(product + ' matched. '));
	        batchResult.appendChild(link);
	        batchResult.appendChild(document.createTextNode('.'));
	      } else if (possibleMatches) {
	        setBatchResultState(null);
	        batchResult.textContent = 'Keep typing to verify the exact published batch.';
	      } else {
	        resetBatchCards();
	        setBatchResultState('is-warning');
	        batchResult.textContent = 'No published COA found for this batch number yet. Check the pack and try again.';
	      }
	    });
	  }

  } catch (error) {
    if (window.console && window.console.warn) {
      window.console.warn('DietXP certification interactions unavailable.', error);
    }
  }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCertificationHub);
  } else {
    initCertificationHub();
  }

})();
